import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN,INDEX_MAIN_PAGE_PATH, OAUTH2_LOGIN_PAGE_PATH,USER_NAME,USER_INFO,UI_CACHE_DB_DICT_DATA ,APPLICATION_CODE,CACHE_INCLUDED_ROUTES,TENANT_ID, MENUS} from '@/store/mutation-types'
import { generateIndexRouter, isOAuth2AppEnv } from '@/utils/util'
import { getAction,postAction } from '@/api/manage'
import { Login } from '@/store/modules/user'

NProgress.configure({ showSpinner: false }) // NProgress Configuration
const whiteList = ['/user/login', '/user/register', '/user/register-result','/user/alteration','/user/apply','/UnifiedSignedTodo','/user-auth-result','/user-auth-result-vendor'] // no redirect whitelist
whiteList.push(OAUTH2_LOGIN_PAGE_PATH)
whiteList.push('/vtj_apply')

function getFirst(menuData){
  let newMenuData=""
  if(menuData.children){
    newMenuData=getFirst(menuData.children[0])
  }else{
    newMenuData=menuData;
  }
  return newMenuData;
}

function findMenuItemByPath(menu, path) {
  // 遍历 menu 中的每个对象
  for (const obj of menu) {
    // 如果找到匹配的 path，则返回该对象
    if (obj.path === path) {
      return obj;
    }

    // 如果对象有 children 属性，并且是一个数组，则递归查找
    if (Array.isArray(obj.children)) {
      const found = findMenuItemByPath(obj.children, path);
      // 如果在 children 中找到匹配的项，则返回它
      if (found) {
        return found;
      }
    }
  }

  // 如果在所有对象中都没有找到匹配的项，则返回 undefined
  return undefined;
}

function findMenuItemByPath2(menu, path) {
  // 遍历 menu 中的每个对象
  for (const obj of menu) {
    // 如果对象有 children 属性，并且是一个数组，则递归查找
    if (Array.isArray(obj.children)) {
      for (let child of obj.children) {
        const combinedPath = obj.path + '/' + child.path;
        if (combinedPath === path) {
          return child;
        }
      }
      const found = findMenuItemByPath2(obj.children, path);
      // 如果在 children 中找到匹配的项，则返回它
      if (found) {
        return found;
      }
    }
  }

  // 如果在所有对象中都没有找到匹配的项，则返回 undefined
  return undefined;
}


async function setLangCode(appCode){
  await getAction("/sys/sysBmApplication/queryLanguageByCode",{code:appCode}).then(res=> {
    if (res.success) {
      let languageSettings = res.result
      let langCode = window.sessionStorage.getItem('USER_LANGUAGE');
      if (languageSettings) {
        let languages = languageSettings.split(",");
        if (languageSettings.indexOf(langCode) == -1) {
          // window.sessionStorage.setItem('USER_LANGUAGE', languages[0]);
          store.dispatch('GetLanguage',languages[0])
        }
      }
    }
  })
}

let refresh = 0;
router.beforeEach(async (to, from, next) => {
  NProgress.start() // start progress bar
  await setLangCode(sessionStorage.getItem(APPLICATION_CODE)||to.query.applicationCode);
  let mailtype = to.query.mail;
  if (mailtype === 'mail') {
    if(to.query.applicationCode!=null&&to.query.applicationCode!=undefined&&to.query.applicationCode!=''){
        sessionStorage.setItem(APPLICATION_CODE,to.query.applicationCode);
    }

    let value = to.query.message;
    if (value) {
      let loginParams = {
        cipherValue: value,
      }
      getAction(`/sys/mailLogin`, loginParams).then(res => {
        if (res.success) {
          const result = res.result
          const userInfo = result.userInfo
          Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
          Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
          Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
          Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
          // next({path: to.path})

          store.dispatch('GetPermissionListByCode',to.query.applicationCode).then(res => {
            const curMenuData = res.result.menu;
            console.log('fox curMenuData : ',curMenuData)

           /* if (curMenuData === null || curMenuData === "" || curMenuData === undefined || curMenuData.length === 0) {
              alert('aaaa  404')
             /!* NProgress.done()
              router.push({ path: "/exception/404" })*!/

              NProgress.done()
              return;
            }*/
          store.dispatch('GetPermissionList').then(res => {
                const menuData = res.result.menu;
            // getAction("/sys/permission/getUserPermissionByToken",{'applicationCode':to.query.applicationCode}).then(res => {
            console.log('aaaa 3333333333',menuData)
            //console.log(res.message)
                if (menuData === null || menuData === "" || menuData === undefined) {
                  return;
                }

                let newPath
                if(to.path&&to.path!=='/'){
                  newPath = {...to}
                }else{
                  if (curMenuData.length > 0) {
                    newPath = getFirst(curMenuData[0])
                    console.log('fox newPath : ' , newPath)
                  } else {
                    newPath = '/exception/404'
                  }
                }
                let constRoutes = [];
                constRoutes = generateIndexRouter(menuData);
                // 添加主界面路由
                store.dispatch('UpdateAppRouter', {constRoutes}).then(() => {
                  // 根据roles权限生成可访问的路由表
                  // 动态添加可访问路由表
                  router.addRoutes(store.getters.addRouters)
                  const redirect = decodeURIComponent(from.query.redirect || newPath.path)

                  console.log('fox redirect : ' , redirect)
                  next({path: redirect})
                })
              })

          })

         // })
        }else{
          window.location.href=process.env.VUE_APP_LOGIN_OUT_PATH;
        }
      }).catch((err) => {

      });
    }
  } else {
    if (Vue.ls.get(ACCESS_TOKEN)) {
      console.log("ACCESS_TOKEN:"+Vue.ls.get(ACCESS_TOKEN))
      console.log("USER_NAME:"+Vue.ls.get(USER_NAME))
      /* has token */
      if(to.path === '/UnifiedSignedTodo'&&!!to.query.username){
        if(Vue.ls.get(USER_NAME).toUpperCase() != to.query.username.toUpperCase()){
          Vue.ls.remove(ACCESS_TOKEN)
          Vue.ls.remove(USER_INFO)
          Vue.ls.remove(USER_NAME)
          Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
          Vue.ls.remove(CACHE_INCLUDED_ROUTES)
          Vue.ls.remove(TENANT_ID)
          Vue.ls.remove(MENUS)
          next({path: '/UnifiedSignedTodo', query: {redirect: to.fullPath}})
        }
      }
      hasToken(to,from,next);
    } else {
      if(to.path === '/UnifiedSignedTodo') {
        let iframeId = to.query.iframeId;
        let username = to.query.username;
        let systype = to.query.systype;
        let formtype = to.query.formtype;
        let ip = to.query.ip
        let formNo = to.query.formNo

        let loginParams = {
          iframeId: iframeId,
          username: username,
          systype: systype,
          formtype: formtype,
          ip: ip,
          formNo: formNo
        }
        asyncLogin(loginParams,to,from,next)
      }else{
        if(process.env.NODE_ENV === 'development'){
          if (whiteList.indexOf(to.path) !== -1) {
            // 在免登录白名单，如果进入的页面是login页面并且当前是OAuth2app环境，就进入OAuth2登录页面
            if (to.path === '/user/login' && isOAuth2AppEnv()) {
              next({path: OAUTH2_LOGIN_PAGE_PATH})
            } else {
              // 在免登录白名单，直接进入
              next()
            }
            NProgress.done()
          } else {
            // 如果当前是在OAuth2APP环境，就跳转到OAuth2登录页面
            let path = isOAuth2AppEnv() ? OAUTH2_LOGIN_PAGE_PATH : '/user/login'
            next({path: path, query: {redirect: to.fullPath}})
            NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
          }
        }else{
          // process.env.NODE_ENV === 'development'
          window.location.href=process.env.VUE_APP_LOGIN_OUT_PATH;
        }
      }
    }
  }
})

async function asyncLogin(loginParams,to,from,next){
  getAction(`/sys/unifiedSignedLogin`, loginParams).then(res => {
    if (res.success) {
      const result = res.result
      const userInfo = result.userInfo
      Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
      Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
      Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
      Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
      next({path:to.path, query: loginParams});
    } else {
      window.location.href = process.env.VUE_APP_LOGIN_OUT_PATH;
    }
  })
}

function hasToken(to,from,next){
  if (to.path === '/user/login' || to.path === OAUTH2_LOGIN_PAGE_PATH) {
    next({path: INDEX_MAIN_PAGE_PATH})
    NProgress.done()
  } else {
    if (store.getters.permissionList.length === 0 && to.path != '/UnifiedSignedTodo') {
      store.dispatch('GetApplicationByUser').then(response => {

        let applicationCode = sessionStorage.getItem(APPLICATION_CODE)
        console.log('wwww : ',applicationCode)
        if (applicationCode === null) {
          let menu = Vue.ls.get(MENUS);
          //let menu = window.localStorage.getItem('pro__env_MENUS')
          let flag = 1;
          if(menu){
            const foundItem = findMenuItemByPath(menu, to.path);
            if (foundItem) {
              if(foundItem.meta.applicationCode){
                flag = 0;
                applicationCode = foundItem.meta.applicationCode;
              }
            }
            const foundItem2 = findMenuItemByPath2(menu, to.path);
            if (foundItem2) {
              if(foundItem2.meta.applicationCode){
                flag = 0;
                applicationCode = foundItem2.meta.applicationCode;
              }
            }
            if(flag===1){
              applicationCode = response.result[0].applicationCode
            }
          }else{
            applicationCode = response.result[0].applicationCode
          }
          console.log('wwww2 : ',applicationCode)
          // this.$store.commit('SET_APPLICATION',applicationCode);
          store.commit('SET_APPLICATION_CODE', applicationCode)
          sessionStorage.setItem(APPLICATION_CODE,applicationCode);
        }
        store.dispatch('GetPermissionListByCode',applicationCode).then(res => {
          let curMenuData = res.result.menu;
          //  alert('bbbb 3333333333')
          if (curMenuData === null || curMenuData === "" || curMenuData === undefined || curMenuData.length === 0) {
            //   alert('bbbb  404')
            window.location.href = '/exception/404'

            //   NProgress.done()

          }else{
            store.dispatch('GetPermissionList').then(res => {

              const menuData = res.result.menu;
              //console.log(res.message)
              if (menuData === null || menuData === "" || menuData === undefined) {
                return;
              }
              let newPath
              let toPathisVaild = false;
              for (let i = 0; i < curMenuData.length; i++) {
                if(curMenuData[i].path===to.path){
                  toPathisVaild = true;
                  break;
                }
              }
              if(to.path&&to.path!=='/'&&toPathisVaild){
                newPath = {...to}
              }else{
                if (curMenuData.length > 0) {
                  newPath = getFirst(curMenuData[0])
                  console.log('fox newPath : ' , newPath)
                } else {
                  newPath = '/exception/404'
                }
              }
              let constRoutes = generateIndexRouter(menuData);
              // 添加主界面路由
              store.dispatch('UpdateAppRouter', {constRoutes}).then(() => {
                // 根据roles权限生成可访问的路由表
                // 动态添加可访问路由表
                router.addRoutes(store.getters.addRouters)
                const redirect = decodeURIComponent(from.query.redirect || newPath.path)
                if (to.path === redirect) {
                  // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                  next({...to, replace: true})
                } else {
                  // 跳转到目的路由
                  next({path: redirect})
                }
              })
            }).catch(() => {
              /* notification.error({
                 message: '系统提示',
                 description: '请求用户信息失败，请重试！'
               })*/
              store.dispatch('Logout').then(() => {
                next({path: '/user/login', query: {redirect: to.fullPath}})
              })
            })
          }
        })


      })
    }else {
      let param = {};
      param.applicationCode = sessionStorage.getItem(APPLICATION_CODE)
      if(param.applicationCode == 'labor'){
        store.dispatch('LaborContractorAdminFlag', param.applicationCode);
      }

      param.path = to.path
      param.name = to.meta.title
      getAction("/sys/permission/userClickPermission", param)
      next()
    }
  }
}


router.afterEach(() => {
  NProgress.done() // finish progress bar
})
